import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BrochureAccess() {
  const { search } = useLocation();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(search).get('token');
    if (!token) {
      setError('No access token provided.');
      return;
    }
    // Navigate the browser directly to the backend endpoint.
    // The backend validates the JWT and issues a 302 redirect to the PDF URL.
    window.location.href = `${API}/api/brochure-access?token=${encodeURIComponent(token)}`;
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Inter, sans-serif', color: '#0D2137' }}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Inter, sans-serif', color: '#0D2137' }}>
      <p>Opening your brochure&hellip;</p>
    </div>
  );
}
